import _ from "lodash";
import client from "lib/apolloClient/client";
import { organizationFragment } from "./ToolingFragments.js";
import {
  getOrganizationFeedQuery,
  getOrganizationDetailsQuery,
  getUserFeedQuery,
  getAcademicYears,
  getProgressReportBaseTemplateListQuery,
  getProgressReportBaseTemplateQuery,
  getInternalToolsGenericQuery,
  getGenericConfigurationsFeedQuery,
  getConfigurationDetailsQuery,
  getConfigurationOptionsQuery,
  getIntegrationTaskCountQuery,
  getMultiAccessIdentityFeedQuery,
  getMultiAccessIdentitiesWithAMAccessQuery,
  getManageLinkedUsersFeedQuery,
  getConfigurationValuesQuery,
  getOrganizationAttachmentDetailsQuery,
  getManagerListQuery,
  getOrganizationAndUserRequestCountQuery,
  getOrganizationPermissionRequestQuery,
  getOrganizationUserAccessRequestQuery,
} from "./ToolingQueries";

export const getProgressReportBaseTemplateListFromCache = () => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProgressReportBaseTemplateListQuery,
      variables: {},
    });
  } catch (error) {
    return {};
  }
  if (queryData != null)
    return _.get(queryData, "documentation.progressReportBaseTemplateList", {});
  else return {};
};

export const getGenericConfigurationsFeedFromCache = ({ filters }) => {
  try {
    const queryData = client.readQuery({
      query: getGenericConfigurationsFeedQuery,
      variables: { filters },
    });
    return _.get(queryData, "platform.genericConfigurationFeed", {});
  } catch (error) {
    return {};
  }
};

export const getMultiAccessIdentitiesWithAMAccessFromCache = () => {
  try {
    const queryData = client.readQuery({
      query: getMultiAccessIdentitiesWithAMAccessQuery,
    });
    return _.get(queryData, "platform.multiAccessIdentitiesWithAMAccess", {});
  } catch (error) {
    return {};
  }
};

export const getMultiAccessIdentityFeedFromCache = ({ filters }) => {
  try {
    const queryData = client.readQuery({
      query: getMultiAccessIdentityFeedQuery,
      variables: { filters },
    });
    return _.get(queryData, "platform.multiAccessIdentityFeed", {});
  } catch (error) {
    return {};
  }
};

export const getManageLinkedUsersFeedFromCache = ({ filters }) => {
  try {
    const queryData = client.readQuery({
      query: getManageLinkedUsersFeedQuery,
      variables: { ...filters },
    });
    return _.get(queryData, "node", {});
  } catch (error) {
    return {};
  }
};

export const getConfigurationDetailsFromCache = ({ id }) => {
  try {
    const queryData = client.readQuery({
      query: getConfigurationDetailsQuery,
      variables: { id },
    });
    return _.get(queryData, "node", {});
  } catch (error) {
    return {};
  }
};

export const getConfigurationOptionsFromCache = () => {
  try {
    const queryData = client.readQuery({
      query: getConfigurationOptionsQuery,
    });
    return _.get(queryData, "platform.configurationToolMutationOptions", {});
  } catch (error) {
    return {};
  }
};

export const getProgressReportBaseTemplateFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getProgressReportBaseTemplateQuery,
      variables: {
        id,
      },
    });
  } catch (error) {
    return {};
  }
  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};

export const getOrganizationAttachmentDetailsFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationAttachmentDetailsQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  return _.get(queryData, "node", {});
};

export const getOrganizationDetailsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationDetailsQuery,
      variables,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getOrganizationFeedFromCache = ({
  filters,
  tagFilters,
  globalConstantsFilter,
  enableEditCloudStorageAccount,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getOrganizationFeedQuery,
      variables: {
        filters,
        tagFilters,
        globalConstantsFilter,
        fetchGlobalConstants: enableEditCloudStorageAccount,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null)
    return _.get(queryData, "platform.organizationFeed", {});
  else return {};
};

export const getOrganizationFeedDetailsFromCache = ({ organizationId }) => {
  let queryData = {};
  try {
    queryData = client.readFragment({
      id: `Organization:${organizationId}`,
      fragment: organizationFragment.organisationFeedDetails,
      fragmentName: "organisationFeedDetailsItem",
    });
  } catch (e) {
    return {};
  }
  return queryData;
};

//User Feed

export const getUserFeedFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getUserFeedQuery,
      variables,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "platform.userFeed", {});
  else return {};
};

export const getAcademicYearsFromCache = id => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getAcademicYears,
      variables: {
        id: id,
      },
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) {
    return _.get(queryData, "node", {});
  } else return {};
};

export const getInternalToolsGenericQueryFromCache = ({ apiType, params }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getInternalToolsGenericQuery,
      variables: {
        apiType,
        params,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) {
    const data = _.get(queryData, "platform.internalToolsGenericQuery", {});
    if (data.isSuccess) return data.data;
  } else return {};
};

export const getIntegrationTaskCountFromCache = ({ id, filters }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getIntegrationTaskCountQuery,
      variables: {
        id,
        filters,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) {
    const data = _.get(queryData, "node", {});
    return data;
  } else return {};
};

export const getConfigurationValuesFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getConfigurationValuesQuery,
      variables,
    });
    return _.get(queryData, "platform.getConfigurationValues.0.values", []);
  } catch (error) {
    return [];
  }
};

export const getManagerListFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getManagerListQuery,
      variables,
    });
    return _.get(queryData, "platform.multiAccessIdentityFeed", {});
  } catch (error) {
    return {};
  }
};

export const getOrganizationAndUserRequestCountFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationAndUserRequestCountQuery,
      variables,
    });
    return _.get(queryData, "platform", {});
  } catch (error) {
    return {};
  }
};

export const getOrganizationPermissionRequestFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationPermissionRequestQuery,
      variables,
    });
    return _.get(queryData, "platform.multiAccessIdentityRequestFeed", {});
  } catch (error) {
    return {};
  }
};

export const getOrganizationUserAccessRequestFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getOrganizationUserAccessRequestQuery,
      variables,
    });
    return _.get(
      queryData,
      "platform.multiAccessIdentityUserAccessRequestFeed",
      {}
    );
  } catch (error) {
    return {};
  }
};
